export enum AppServiceCategoryNamesEnum {
  PAY = 'payment',
  MOBILE = 'mobile',
  WEALTH = 'wealth',
  INSURANCE = 'insurance',
  VEHICLE = 'vehicle',
  INSTALLMENT = 'installment',
  SUGGESTED_SERVICES = 'suggested_services',
}
